import React, { useEffect, useState } from 'react'
import { Button, Carousel, Col, Form, Row } from 'react-bootstrap';

// region Local Import
import logo_img from './assets/images/Login/logo-dark.png';
// import bg_img from './assets/images/Login/login-bg.svg';
import bg_img from './assets/images/Login/login-img1.jpg';
import bg_img1 from './assets/images/Login/login-img2.jpg';
import googleLogo from './assets/images/Login/google-icon.svg';
import linkedInLogo from './assets/images/Login/linkedin-icon.svg'
import oktaLogo from './assets/images/Login/okta-logo.svg'
import microsoftLogo from './assets/images/Login/microsoft-icon.svg'
import { Link, useNavigate } from 'react-router-dom';
import companyLogo from './assets/images/Login/signin-company-logo.svg';
import eyeClose from './assets/images/Login/eye-close.svg';
import eyeOpen from './assets/images/Login/eye-open.svg';
import companySmallLogo from './assets/images/Sidebar/company-small-logo.svg';
import { loadSignInTokenData, loadUserManagementData, postSignInDatas } from './redux/action';
import { useDispatch } from 'react-redux';
import * as HeaderAuthentication from '../src/components/HeaderAuthentication';
import failedImg from '../src/assets/images/Login/failedImg.svg';
import { baseURL } from './components/BaseUrl';
// endregion

// Okta Configurations
const oktaDomain = "https://dev-11921071.okta.com";
const clientId = "0oana2n5klKQnEcMg5d7";
// const redirectUri = "http://localhost:3001/";
const redirectUri =
    window.location.hostname === "localhost"
        ? "http://localhost:3000/callback"
        : "https://excomatix.betaphase.in/callback";
const state = "1234";

// Generate Code Verifier
function generateCodeVerifier() {
    const randomValues = new Uint8Array(64);
    window.crypto.getRandomValues(randomValues);
    return btoa(String.fromCharCode.apply(null, randomValues))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '');
}

// Generate Code Challenge
async function generateCodeChallenge(codeVerifier) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier))
        .then(buffer => {
            return btoa(String.fromCharCode(...new Uint8Array(buffer)))
                .replace(/=/g, '')
                .replace(/\+/g, '-')
                .replace(/\//g, '_');
        });
}

// Okta Login Function
async function loginWithOkta() {
    const codeVerifier = generateCodeVerifier();
    sessionStorage.setItem('code_verifier', codeVerifier);

    const codeChallenge = await generateCodeChallenge(codeVerifier);
    const authUrl = `${oktaDomain}/oauth2/default/v1/authorize?client_id=${clientId}&response_type=code&scope=openid profile email offline_access&redirect_uri=${redirectUri}&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

    // console.log("Redirecting to:", authUrl);
    window.location.href = authUrl;
}

function loginWithMicrosoft() {
    // const clientId = "a821f06c-fc66-4f64-8dbe-c1542ae82289";
    // // const redirectUri = "https://excomatix.betaphase.in/"; // Must match registered URI in Azure
    // const redirectUri =
    //     window.location.hostname === "localhost"
    //         ? "http://localhost:3000/"
    //         : "https://excomatix.betaphase.in/";
    // const scope = "openid profile email";
    // const responseType = "code";

    // const authUrl = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" +
    //     "?client_id=" + encodeURIComponent(clientId) +
    //     "&response_type=" + encodeURIComponent(responseType) +
    //     "&redirect_uri=" + encodeURIComponent(redirectUri) +
    //     "&scope=" + encodeURIComponent(scope) +
    //     "&response_mode=query" +
    //     "&state=microsoft"; // ✅ This differentiates Microsoft login

    // window.location.href = authUrl;

    // const clientId = "a821f06c-fc66-4f64-8dbe-c1542ae82289";
    const clientId = "ad982bcc-bdf5-473d-ad72-64a504a907f5";
    // const clientId = "2tY8Q~9HCMAzRcSYH0bU5BOmJfUg6TuA1P7bqbCV";
    const redirectUri = window.location.hostname === "localhost"
        ? "http://localhost:3000/callback"
        : "https://excomatix.betaphase.in/callback"; // Must match registered URI in Azure
    const scope = "openid profile email offline_access";
    //const scope = "api://a821f06c-fc66-4f64-8dbe-c1542ae82289/openid";
    // const response_type = "id_token token";
    const responseType = "code"; // Change 'token' to 'code'

    const authUrl = "https://login.microsoftonline.com/f530b5f9-ab7e-452a-86fb-3b5a5a0250f0/oauth2/v2.0/authorize" +
        "?client_id=" + encodeURIComponent(clientId) +
        "&response_type=" + encodeURIComponent(responseType) + // Use 'code' instead of 'token'
        "&redirect_uri=" + encodeURIComponent(redirectUri) +
        "&scope=" + encodeURIComponent(scope) +
        //"&response_type=" + encodeURIComponent(scope) +
        "&response_mode=query" + // 'query' ensures the code is in the URL
        "&prompt=login" +        // Forces login every time (no silent SSO)
        // "&amr_values=mfa" +      // Forces MFA (Microsoft Authenticator OTP); // 'query' ensures the code is in the URL
        "&state=microsoft";      // ✅ This differentiates Microsoft login

    window.location.href = authUrl;
}

function Signin() {
    let dispatch = useDispatch();
    const signInToken = JSON.parse(sessionStorage.getItem('signInToken'));

    const [passwordType, setPasswordType] = useState("password");
    const [signInData, setSignInData] = useState(
        {
            EmailID: "",
            Password: ""
        }
    )
    const [errorMessage, setErrorMessage] = useState({ EmailID: '', Password: '' }); // State for error messages
    const [successMessage, setSuccessMessage] = useState(''); // State to manage success message
    const [isLicenseExpired, setIsLicenseExpired] = useState(false);  // New state to handle expired license
    const [isVerificationContentVisible, setIsVerificationContentVisible] = useState(false); // State for controlling visibility of verification content
    const [failureMessage, setFailureMessage] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [rememberMe, setRememberMe] = useState(false); // State for Remember Me checkbox
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };
    // const navigateToOtpPage = () => {
    //     setTimeout(() => {
    //         window.location.href = '#/verifyOtp'
    //     }, 1500); // Delay
    // }

    const navigate = useNavigate();
    const navigateToOtpPage = () => {
        setTimeout(() => {
            navigate('/verifyOtp'); // ✅ No reload, sessionStorage will be available
        }, 1500); // Delay if needed
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSignInData({
            ...signInData,
            [name]: value
        });

        // Clear error message when the user starts typing
        setErrorMessage({
            ...errorMessage,
            [name]: ''
        });
    };

    // Load credentials from localStorage on mount
    useEffect(() => {
        const rememberedCredentials = JSON.parse(localStorage.getItem("rememberedCredentials"));
        if (rememberedCredentials) {
            setSignInData({
                EmailID: rememberedCredentials.email,
                Password: rememberedCredentials.pswd
            });
            setRememberMe(true);
        }
    }, []);

    // Handle "Remember me" toggle
    const toggleRememberMe = () => {
        setRememberMe(!rememberMe);
    };

    // Validate form fields
    const validateFields = () => {
        const { EmailID, Password } = signInData;
        let errors = {};
        let formIsValid = true;

        if (!EmailID) {
            formIsValid = false;
            errors.EmailID = 'Email is required';
        }

        if (!Password) {
            formIsValid = false;
            errors.Password = 'Password is required';
        }

        setErrorMessage(errors);
        setIsDisabled(false);
        return formIsValid;
    };

    // const AddSignInData = (e) => {
    //     e.preventDefault();
    //     setIsDisabled(true);

    //     // Validate the fields before making the API call
    //     if (!validateFields()) return;

    //     // If "Remember Me" is checked, save credentials to localStorage
    //     if (rememberMe) {
    //         const credentials = { email: signInData.EmailID, pswd: signInData.Password, remember: rememberMe };
    //         localStorage.setItem("rememberedCredentials", JSON.stringify(credentials));
    //     } else {
    //         localStorage.removeItem("rememberedCredentials"); // Clear saved credentials
    //     }

    //     let requestOption = {
    //         method: "POST",
    //         mode: "cors",
    //         headers: HeaderAuthentication.postAuthOfExcomatix,
    //         body: JSON.stringify(signInData),
    //     };
    //     dispatch(postSignInDatas(requestOption, navigateToOtpPage, handleResponse, setIsDisabled));
    // }

    const AddSignInData = (e) => {
        e.preventDefault();

        if (!validateFields()) {
            console.log("Validation failed, stopping execution.");
            setIsDisabled(false); // Re-enable button if validation fails
            return;
        }

        setIsDisabled(true);

        if (rememberMe) {
            const credentials = { email: signInData.EmailID, pswd: signInData.Password, remember: rememberMe };
            localStorage.setItem("rememberedCredentials", JSON.stringify(credentials));
        } else {
            localStorage.removeItem("rememberedCredentials");
        }

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfExcomatix,
            body: JSON.stringify(signInData),
        };

        dispatch(postSignInDatas(requestOption, navigateToOtpPage, handleResponse, setIsDisabled));
    };

    // Handle the server response for success or failure
    // const handleResponse = (response) => {
    //     if (response.Success === '1') {
    //         setSuccessMessage(response.Msg || "Successfully signed in!");
    //         setErrorMessage({ EmailID: '', Password: '' });
    //         // Redirect to another page or trigger other actions if needed
    //     } else {
    //         setErrorMessage({ EmailID: '', Password: response.Msg || 'An error occurred. Please try again.' });
    //         setSuccessMessage('');
    //     }
    // };

    const handleResponse = (response) => {
        if (response.Success === 1) {
            setSuccessMessage(response.Msg || "Successfully signed in!");
            setErrorMessage({ EmailID: '', Password: '' });  // Reset error messages on success
        } else {
            setIsDisabled(false);
            // Check for specific failure conditions
            if (response.Msg === "Wrong Password") {
                // Set error message for Password field
                setErrorMessage({ EmailID: '', Password: response.Msg });
            } else if (response.Msg === "Email ID does not exist") {
                // Set error message for Email field
                setErrorMessage({ EmailID: response.Msg, Password: '' });
            } else if (response.Msg === "License Expired") {
                // Set a general failure message for License Expired
                setFailureMessage('Your license has expired. Kindly contact support for assistance.');
                setErrorMessage({ EmailID: '', Password: '' });  // Reset any field-specific errors
            } else {
                // Handle any other general errors
                // setErrorMessage({ EmailID: '', Password: 'An error occurred. Please try again.' });
                setErrorMessage({ EmailID: '', Password: response.Msg });
            }
            setSuccessMessage('');
        }
    };


    // Function to hide the expired content when "Continue" button is clicked
    const handleContinueClick = () => {
        setIsVerificationContentVisible(true); // Hide verification content
    };

    const [message, setMessage] = useState("Processing...");

    // useEffect(() => {
    //     // Check if the URL has a 'code' parameter
    //     const urlParams = new URLSearchParams(window.location.search);
    //     const authorizationCode = urlParams.get("code");

    //     if (authorizationCode) {
    //         // Retrieve code_verifier from sessionStorage
    //         const codeVerifier = sessionStorage.getItem("code_verifier");

    //         if (!codeVerifier) {
    //             setMessage("Code verifier not found in session storage.");
    //             return;
    //         }

    //         fetch(`${baseURL}/accountservices/api/account/AuthenticateWithOkta`, {
    //             method: "POST",
    //             mode: "cors",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
    //             },
    //             body: JSON.stringify({
    //                 AuthorizationCode: authorizationCode,
    //                 CodeVerifier: codeVerifier,
    //             }),
    //         })
    //             .then((response) => {
    //                 if (!response.ok) {
    //                     throw new Error(`HTTP Error: ${response.status}`);
    //                 }
    //                 return response.json();
    //             })
    //             .then((resp) => {
    //                 setMessage("Authentication Successful.");
    //                 sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
    //                 sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
    //                 sessionStorage.setItem('Success', '1');
    //                 window.location.href = '/';
    //             })
    //             .catch((error) => {
    //                 setMessage("Authentication Failed: " + error.message);
    //             });
    //     }
    // }, []);

    const generatedToken = () => {
        dispatch(loadSignInTokenData());
    }

    const callSingleActiveSessionApi = async () => {
        try {
            const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
            let CustomerID = null;

            if (signInDetails[0]?.SignInType === "SuperAdmin") {
                CustomerID = signInDetails[0]?.SuperAdminID;
            } else if (signInDetails[0]?.SignInType === "ClientAdmin") {
                CustomerID = signInDetails[0]?.CompanyID;
            } else if (signInDetails[0]?.SignInType === "User") {
                CustomerID = signInDetails[0]?.UserID;
            }

            const response = await fetch(`${baseURL}/accountservices/api/account/SingleActiveSession`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                },
                body: JSON.stringify({
                    SigninType: signInDetails[0]?.SignInType,
                    DeviceType: "Web",
                    SigninID: CustomerID
                })
            });

            const result = await response.json();

            if (result?.Msg) {
                sessionStorage.setItem("signInToken", JSON.stringify(result.Msg));
                console.log("✅ Token stored successfully");
            } else {
                console.warn("⚠️ Token response missing `Msg` field");
            }

        } catch (error) {
            console.error("🚨 Token fetch failed", error);
        }
    };


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const authorizationCode = urlParams.get("code");
        const stateParam = urlParams.get("state"); // Identify Microsoft vs Okta
        const codeVerifier = sessionStorage.getItem("code_verifier"); // Only exists for Okta

        if (authorizationCode) {
            if (stateParam === "microsoft") {
                // ✅ Microsoft Authentication
                fetch(`${baseURL}/accountservices/api/account/AuthenticateWithMicrosoft`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                    },
                    body: JSON.stringify({ AuthorizationCode: authorizationCode }),
                })
                    .then((res) => res.json())
                    .then(async (resp) => {
                        if (resp.Success) {
                            sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                            sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
                            sessionStorage.setItem("Success", "1");
                            await callSingleActiveSessionApi();
                            window.location.href = "/";
                        } else {
                            setMessage("Microsoft Authentication Failed: " + resp.Msg);
                        }
                    })
                    .catch((error) => {
                        setMessage("Microsoft Authentication Failed: " + error.message);
                    });
            } else if (codeVerifier) {
                // ✅ Okta Authentication (only triggered if `code_verifier` exists)
                fetch(`${baseURL}/accountservices/api/account/AuthenticateWithOkta`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5"
                    },
                    body: JSON.stringify({ AuthorizationCode: authorizationCode, CodeVerifier: codeVerifier }),
                })
                    .then((res) => res.json())
                    .then(async (resp) => {
                        if (resp.Success) {
                            sessionStorage.setItem("SignInDetails", JSON.stringify(resp.SignInDetails));
                            sessionStorage.setItem("AssignedModules", JSON.stringify(resp.AssignedModules));
                            sessionStorage.setItem("Success", "1");
                            await callSingleActiveSessionApi();
                            window.location.href = "/";
                        } else {
                            setMessage("Okta Authentication Failed: " + resp.Msg);
                        }
                    })
                    .catch((error) => {
                        setMessage("Okta Authentication Failed: " + error.message);
                    });
            } else {
                setMessage("Unknown Authentication Attempt.");
            }
        }
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                event.preventDefault(); // Prevent default form submission

                // Ensure input values are updated before calling AddSignInData
                setTimeout(() => {
                    AddSignInData(new Event("submit")); // Ensure event object is valid
                }, 100);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [signInData]); // Depend on signInData to capture the latest input values    

    return (
        <div className='signin-main-container'>
            <Row className='lm-signin-login-row'>

                <Col md={6} className='lm-signin-form-col'>
                    {isLicenseExpired && !isVerificationContentVisible ? (
                        <div className="company-verification-content">
                            <img
                                src={companySmallLogo}
                                alt="Company Logo"
                                className='company-small-logo'
                            />
                            <span>Expired !</span>
                            <p>{failureMessage}</p>
                            <div className='lm-login-form'>
                                <div className="lm-login-form-btn verification-btn">
                                    <img src={failedImg} alt="failed" className="failure-img" />
                                    <Button onClick={handleContinueClick}>Continue</Button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <img
                                src={companySmallLogo}
                                alt="Company Logo"
                                className='company-small-logo'
                            />
                            <img src={companyLogo} alt="Company Logo" className="company-big-logo" />
                            <h4 className="lm-wlcm-txt">Sign In</h4>
                            <p>Sign in to your account to start using EXCOMATIX</p>
                            <Form className='lm-login-form'>
                                <div className='input-box'>
                                    <div className='input-box1'>
                                        <label>Email</label>
                                        <Form.Control
                                            type="email"
                                            id="EmailID"
                                            name="EmailID"
                                            value={signInData.EmailID}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {errorMessage.EmailID && <div className="text-danger d-flex pt-2">{errorMessage.EmailID}</div>}
                                    <div style={{ position: "relative" }}>
                                        <div className='input-box2'>
                                            <label>Password</label>
                                            <Form.Control
                                                type={passwordType}
                                                id="Password"
                                                name="Password"
                                                value={signInData.Password}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="pass-hide-show">
                                            {passwordType === "password" ? (
                                                <img src={eyeClose} alt="" onClick={togglePassword} />
                                            ) : (
                                                <img src={eyeOpen} alt="" onClick={togglePassword} />
                                            )}
                                        </div>
                                    </div>
                                    {errorMessage.Password && <div className="text-danger d-flex pt-2">{errorMessage.Password}</div>}
                                </div>
                                {/* <br /> */}
                                <div className="forgot-pass-n-remind-me">
                                    <div className="signIn-footer ">
                                        <div className="create-account-div d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={rememberMe}
                                                onChange={toggleRememberMe}
                                            />&nbsp;&nbsp;
                                            <div
                                                className="login-remember-me"
                                            >
                                                Remember my preferences
                                            </div>
                                        </div>
                                    </div>
                                    <div className="forget-pasword-div">
                                        <Link
                                            to="/forgetpassword"
                                            className="lm-pswd-reset"
                                        >
                                            Forgot Password?
                                        </Link>
                                    </div>
                                </div>
                                <div className='lm-login-form-btn'>
                                    {/* <p className='lm-pswd-reset'>Forgot password?</p> */}
                                    <Button onClick={AddSignInData} disabled={isDisabled}>Sign In</Button>
                                </div>

                                {/* Display error or success message */}
                                {/* {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>} */}
                                {successMessage && <div className="text-success mt-3">{successMessage}</div>}

                                {/* <p className='lm-devider'><span>Or</span></p> */}
                                <div class="divider-container">
                                    <div class="line"></div>
                                    <p class="text">Or continue with</p>
                                    <div class="line"></div>
                                </div>

                                <div className='lm-login-btns-section'>
                                    {/* <div className='btn-div'>
                                        <img src={googleLogo} alt="google" className='login-cmp-icons' />
                                        <span class="sr-only">Google</span>
                                        <span aria-hidden="true" class="login-tooltip">Google</span>
                                    </div>
                                    <div className='btn-div'>
                                        <img src={linkedInLogo} alt="linkedin" className='login-cmp-icons' />
                                        <span class="sr-only">LinkedIn</span>
                                        <span aria-hidden="true" class="login-tooltip">LinkedIn</span>
                                    </div> */}
                                    <div className='btn-div' onClick={loginWithMicrosoft}>
                                        <img src={microsoftLogo} alt="linkedin" className='login-cmp-icons' />
                                        <span class="sr-only">Microsoft</span>
                                        <span aria-hidden="true" class="login-tooltip">Microsoft</span>
                                    </div>
                                    <div className='btn-div' onClick={loginWithOkta}>
                                        <img src={oktaLogo} alt="linkedin" className='login-cmp-icons' />
                                        <span class="sr-only">Okta</span>
                                        <span aria-hidden="true" class="login-tooltip">Okta</span>
                                    </div>
                                </div>
                                {/* <p className='m-0'><span className='not-registered'>Not registered?</span> <span className='lm-signup-link'>Register</span></p> */}
                            </Form>
                        </>
                    )}
                </Col>
                <Col md={6} className='lm-signin-image-col'>
                    <Carousel
                        style={{ width: "100%" }}
                        controls={false}
                        indicators={false}
                    // interval={2000}
                    >
                        <Carousel.Item>
                            <div className='lm-bg-img-div'>
                                <img src={bg_img} alt="" className='lm-bg-img' />
                                <div className="carousel-content">
                                    <img src={companyLogo} alt="Company Logo" className="carousel-logo" />
                                    {/* <p className="carousel-text">
                                        CRM dashboard uses line charts to visualize customer-related metrics and trends over time.
                                    </p> */}
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className='lm-bg-img-div'>
                                <img src={bg_img1} alt="" className='lm-bg-img' />
                                <div className="carousel-content">
                                    <img src={companyLogo} alt="Company Logo" className="carousel-logo" />
                                    {/* <p className="carousel-text">
                                        CRM dashboard uses line charts to visualize customer-related metrics and trends over time.
                                    </p> */}
                                </div>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </Col>
            </Row>
        </div>
    )
}

export default Signin;
